import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING._8};
  padding-top: 6px;

  h4 {
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  }
`;
